import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(initPropertyWorker),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(propertiesSaga);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { takeEvery, put, call } from 'redux-saga/effects';
import { validateJson } from '../../../utils/jsonschema/validator';
import { propertiesRequestData } from '../../slices/properties/properties';
import { ACTION } from '../constants';
import { Endpoints } from '../../../api/Constants';
import store from '../../store';
import { parseInitPropertyResponse } from '../../../utils/properties';
import handleLoggerErrorEvents from '../handleLoggerErrorEvents';
export function initPropertyWorker(_ref) {
  var payload, response, texts, assetBaseUrl, parsedResponse, textsFile;
  return _regeneratorRuntime.wrap(function initPropertyWorker$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _ref.payload;
          _context.next = 3;
          return put(ACTION.PROPERTIES.isFetching(true));

        case 3:
          _context.prev = 3;
          _context.next = 6;
          return call(ACTION.PROPERTIES.fetchData, payload);

        case 6:
          response = _context.sent;

          if (!validateJson(Endpoints.PROPERTIES, response[0])) {
            _context.next = 21;
            break;
          }

          texts = response[0].texts;
          assetBaseUrl = store.getState().app.assetsUrls.ImagesCdnBaseUrl;
          parsedResponse = parseInitPropertyResponse(response[0], assetBaseUrl);

          if (!(assetBaseUrl && texts)) {
            _context.next = 17;
            break;
          }

          _context.next = 14;
          return call(ACTION.PROPERTIES.fetchTexts, {
            assetBaseUrl: assetBaseUrl,
            texts: texts
          });

        case 14:
          _context.t0 = _context.sent;
          _context.next = 18;
          break;

        case 17:
          _context.t0 = {};

        case 18:
          textsFile = _context.t0;
          _context.next = 21;
          return put(ACTION.PROPERTIES.requestDataSuccess(_objectSpread(_objectSpread({}, parsedResponse), textsFile && Object.keys(textsFile).length > 0 && {
            textsFile: textsFile
          })));

        case 21:
          _context.next = 28;
          break;

        case 23:
          _context.prev = 23;
          _context.t1 = _context["catch"](3);
          _context.next = 27;
          return put(ACTION.PROPERTIES.requestError(_context.t1));

        case 27:
          handleLoggerErrorEvents(_context.t1);

        case 28:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[3, 23]]);
}

function propertiesSaga() {
  return _regeneratorRuntime.wrap(function propertiesSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return takeEvery(propertiesRequestData, initPropertyWorker);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

export default propertiesSaga;